// Generated by purs version 0.13.8
"use strict";
var Control_Monad_Trans_Class = require("../Control.Monad.Trans.Class/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var ManageTutorials = function (Monad0, completeTutorial, createTutorial, deleteTutorial, getTutorial, saveTutorial) {
    this.Monad0 = Monad0;
    this.completeTutorial = completeTutorial;
    this.createTutorial = createTutorial;
    this.deleteTutorial = deleteTutorial;
    this.getTutorial = getTutorial;
    this.saveTutorial = saveTutorial;
};
var saveTutorial = function (dict) {
    return dict.saveTutorial;
};
var getTutorial = function (dict) {
    return dict.getTutorial;
};
var deleteTutorial = function (dict) {
    return dict.deleteTutorial;
};
var createTutorial = function (dict) {
    return dict.createTutorial;
};
var completeTutorial = function (dict) {
    return dict.completeTutorial;
};
var manageTutorialsHalogenM = function (dictManageTutorials) {
    return new ManageTutorials(function () {
        return Halogen_Query_HalogenM.monadHalogenM;
    }, (function () {
        var $2 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageTutorials.Monad0());
        var $3 = completeTutorial(dictManageTutorials);
        return function ($4) {
            return $2($3($4));
        };
    })(), (function () {
        var $5 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageTutorials.Monad0());
        var $6 = createTutorial(dictManageTutorials);
        return function ($7) {
            return $5($6($7));
        };
    })(), (function () {
        var $8 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageTutorials.Monad0());
        var $9 = deleteTutorial(dictManageTutorials);
        return function ($10) {
            return $8($9($10));
        };
    })(), (function () {
        var $11 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageTutorials.Monad0());
        var $12 = getTutorial(dictManageTutorials);
        return function ($13) {
            return $11($12($13));
        };
    })(), (function () {
        var $14 = saveTutorial(dictManageTutorials);
        return function ($15) {
            return (function (v) {
                var $16 = Control_Monad_Trans_Class.lift(Halogen_Query_HalogenM.monadTransHalogenM)(dictManageTutorials.Monad0());
                return function ($17) {
                    return $16(v($17));
                };
            })($14($15));
        };
    })());
};
module.exports = {
    completeTutorial: completeTutorial,
    createTutorial: createTutorial,
    deleteTutorial: deleteTutorial,
    getTutorial: getTutorial,
    saveTutorial: saveTutorial,
    ManageTutorials: ManageTutorials,
    manageTutorialsHalogenM: manageTutorialsHalogenM
};
